<mat-checkbox
  [checked]="checked"
  [indeterminate]="indeterminate"
  [disabled]="disabled"
  [aria-label]="ariaLabel"
  (click)="$event.stopPropagation()"
  (change)="toggle()"
  (keydown.enter)="toggleWithEnter($event)"
  (keydown.space)="$event.stopPropagation()"
></mat-checkbox>
